import {
  FormControlLabel,
  FormHelperText,
  Switch,
  type SxProps,
  type Theme,
} from "@mui/material";
import { memo, useCallback, type ChangeEvent } from "react";
import { type FieldCopy } from "../tenedi-connection-copy";

const styles = {
  helper: { mt: -0.5, mb: 1, ml: 6 } satisfies SxProps<Theme>,
};

type SettingSwitchProps<Name extends string> = {
  readonly name: Name;
  readonly copy: FieldCopy;
  readonly checked: boolean;
  readonly disabled: boolean;
  readonly onChange: (name: Name, checked: boolean) => void;
};

const SettingSwitchInner = <Name extends string>({
  name,
  copy,
  checked,
  disabled,
  onChange,
}: SettingSwitchProps<Name>) => {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(name, event.target.checked);
    },
    [name, onChange],
  );
  return (
    <>
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            disabled={disabled}
            onChange={handleChange}
          />
        }
        label={copy.label}
      />
      {copy.helper !== undefined && (
        <FormHelperText sx={styles.helper}>{copy.helper}</FormHelperText>
      )}
    </>
  );
};

/** One on/off partnership setting with its plain-language label and helper text. */
const SettingSwitch = memo(SettingSwitchInner) as typeof SettingSwitchInner & {
  displayName?: string;
};
SettingSwitch.displayName = "SettingSwitch";

export default SettingSwitch;
